import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        yellow: '#e9de25',
        'alternative-yellow': '#ffb20f',
        'dark-blue': '#729EB8',
        mint: '#67c3b4'
      }
    }
  },
  icons: {
    iconfont: 'fa' // 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' ||
  }
})
